import tw, { styled } from 'twin.macro';

export default styled.div(() => [tw`fixed bottom-0 inset-x-0 w-full h-8 bg-yellow-base`]);
